import type {ReactElement} from 'react'
import {SwiperSlide} from 'swiper/react'

import {useSwiper} from 'swiper/react'

import Image from 'next/image'
import React from 'react'
interface Props {
  image: any
}
export default function ProductSliderItem({image}: Props): ReactElement {
  const swiper = useSwiper()
  return (
    <>
      <div className="w-full relative h-[250px] lg:h-[400px] xl:h-[430px]">
        <Image
          src={process.env.NEXT_PUBLIC_CDN_URL + '/' + image}
          className="w-full h-full object-cover"
          alt={'product-image'}
          width={500}
          height={500}
        />
      </div>
    </>
  )
}
